import { useTranslation } from 'react-i18next';

import { formatTimestampToDay } from 'support/helpers/dateTime/dateTime';
import { DocumentType } from 'support/types';

import { useShippingNoticeSummaryValues } from '../DocumentSummary/hooks/useShippingNoticeSummary';
import { SummaryAccordion } from '../SummaryAccordion/SummaryAccordion';

export const CreateShippingNoticeSummary = ({ documentType }: { documentType: DocumentType.shippingNotice }) => {
  const { t } = useTranslation();
  const shippingNoticeSummary = useShippingNoticeSummaryValues();
  return (
    <SummaryAccordion
      header={{
        label: t('webedi:documentSummary.title', {
          documentType: t(`common:messageTypes.singular.${documentType}`),
        }),
        value: Math.round(shippingNoticeSummary.totalQuantity),
        valueLabel: t('webedi:documentSummary.shippingNotice.totalQuantity.label'),
      }}
      bodyItems={[
        {
          label: t('webedi:documentSummary.shippingNotice.deliveryDate.label'),
          value: formatTimestampToDay(shippingNoticeSummary.deliveryDate) ?? '—',
        },
        {
          label: t('webedi:documentSummary.shippingNotice.shippedLineItemCount.label'),
          value: Math.round(shippingNoticeSummary.lineItemCount),
        },
      ]}
      footer={{
        label: t('webedi:documentSummary.shippingNotice.totalQuantity.label'),
        value: Math.round(shippingNoticeSummary.totalQuantity),
      }}
    />
  );
};
